import { logger } from '@/lib/logger';

export function logOutOfStockError(error: any, context: any = {}) {
  // Check if this is an out-of-stock error
  if (!error?.message) return;
  
  const message = error.message.toLowerCase();
  const isOutOfStock = message.includes('sold out') || 
                      message.includes('out of stock')

  if (!isOutOfStock) return;

  const logData = {
    errorType: 'OUT_OF_STOCK_ERROR',
    errorMessage: error.message,
    ...context,
    timestamp: new Date().toISOString(),
    environment: process.env.NEXT_PUBLIC_STAGE || 'unknown',
    store: process.env.NEXT_PUBLIC_STORE || 'unknown',
    userAgent: typeof window !== 'undefined' ? window.navigator.userAgent : 'server',
    url: typeof window !== 'undefined' ? window.location.href : 'server',
  };

  // Console log for immediate visibility
  console.error('🚨 OUT OF STOCK ERROR:', logData);
  
  // Datadog log
  logger.error(logData, 'Out of stock error detected');
} 